import $ from 'jquery';

export default () => {
  $(document).ready(function () {
    var $stickies = $('.filter-button');

    if ($stickies.length) {
      $('body').on('scroll', function () {
        apply_sticky_class($stickies[0]);
      });
    }
  });

  function apply_sticky_class(sticky) {
    let currentOffset = sticky.getBoundingClientRect().top;
    let stickyOffset = parseInt(getComputedStyle(sticky).top.replace('px', ''));
    let isStuck = currentOffset <= stickyOffset;

    if (isStuck) {
      sticky.classList.add('is-sticky');
    } else {
      sticky.classList.remove('is-sticky');
    }
  }
  $('.js-toggle-filters').on('click', function () {
    $('.custom-filters-cont').toggleClass('is-visible');
    $('body').toggleClass('block-scroll');
  });
}